import { FC } from 'react';
import { Avatar, AvatarProps } from 'antd';
import { generateColor, generateGravatarUrl, getUserInitials } from 'utils/string.utils';

const mapSize = {
  xs: '18px',
  xl: '38px',
  lg40: '40px',
};

const mapFontSize = {
  xs: '11px',
  xl: '26px',
  lg40: '24px',
};

const isCustomSize = (size: UserAvatarProps['size']): size is keyof typeof mapSize => {
  return size !== undefined && size in mapSize;
};

export interface UserAvatarProps extends Omit<AvatarProps, 'size'> {
  user?: Record<string, any>;
  size?: 'large' | 'small' | keyof typeof mapSize;
}

const UserAvatar: FC<UserAvatarProps> = ({ user, size, className = '', style = {}, ...props }) => {
  const initials = getUserInitials(user as any);

  return (
    <Avatar
      className={`ant-avatar-full-string ${className}`}
      shape="square"
      size={!isCustomSize(size) ? size : undefined}
      src={generateGravatarUrl(user?.email)}
      style={{
        width: isCustomSize(size) ? mapSize[size] : undefined,
        height: isCustomSize(size) ? mapSize[size] : undefined,
        lineHeight: isCustomSize(size) ? mapSize[size] : undefined,
        fontSize: isCustomSize(size) ? mapFontSize[size] : undefined,
        ...style,
      }}
      {...props}
    >
      <div style={{ background: generateColor(user?.email ?? user?.name) }}>{initials}</div>
    </Avatar>
  );
};

export default UserAvatar;
